// returns non-PII data from a datalayer event

import type { DataLayer } from './types';

// used for logging
export const scrubPIIFromDataLayer = (data: DataLayer) => ({
  event: data.event,
  ecommerce_data: data.ecommerce_data,
  eventPath: data.eventPath,
});
